import useTranslation from "next-translate/useTranslation";
import Head from "next/head";
import EstimationPagesHelper, {
  getServerSideHelper,
} from "pagesHelpers/EstimationPagesHelper";
import { useEffect } from "react";
import { wrapper } from "redux/configureStore";
import api_call_v2 from "utils/API_CALL/api_call_v2";
import formatUrl from "utils/FormatUrl";

const RendringPage = (props) => {
  const { t, lang } = useTranslation("Estimation");
  useEffect(() => {
    api_call_v2(
      undefined,
      "post",
      "track/pageview",
      {
        object_type: formatUrl(
          `/estimation/map?version=${props.version}`,
          lang
        ),
      },
      "v3"
    );
  }, []);
  return (
    <>
      {props.nofollow ? (
        <Head>
          <meta name="robots" content="noindex, nofollow" />
        </Head>
      ) : null}

      <EstimationPagesHelper />
    </>
  );
};
export default RendringPage;

export const getServerSideProps = wrapper.getServerSideProps((store) => {
  return async (ctx) => {
    let props: any = {
      version: ctx.query
        ? ctx.query.version == "estimation"
          ? "estimation"
          : "estimation"
        : "estimation",
    };
    let error = true;
    try {
      props = await getServerSideHelper(store, ctx, 0);
      error = false;
    } catch (e) {}
    return error
      ? {
          props: {
            version: "estimation",
            nofollow:
              ctx.query.version || ctx.query.lat || ctx.query.gid
                ? true
                : false,
          },
        }
      : {
          props: {
            ...props.props,
            version: ctx.query
              ? ctx.query.version
                ? ctx.query.version
                : "estimation"
              : "estimation",
            nofollow:
              ctx.query.version || ctx.query.lat || ctx.query.gid
                ? true
                : false,
          },
        };
  };
});
